const armorLink = (a: HTMLAnchorElement, href: string): void => {
	a.href = href;
	if (href.startsWith('https://')) {
		a.target = '_blank';
		a.rel = 'noreferrer';
	}
};

export const load = (src: string, callback: () => void): void => {
	const script = document.createElement('script');
	script.src = src;
	script.addEventListener('load', callback);
	document.head.append(script);
};

export const addLink = (tag: string, text: string, href: string, className?: string): HTMLElement => {
	const container = document.createElement(tag);
	const a = document.createElement('a');
	a.textContent = text;
	armorLink(a, href);
	container.append(a);
	if (className) {
		container.className = className;
	}
	return container;
};

export const createTd = (text: string, className?: string): HTMLTableCellElement => {
	const td = document.createElement('td');
	td.textContent = text;
	if (className) {
		td.className = className;
	}
	return td;
};

export const insertRow = (...tds: HTMLElement[]): void => {
	const tr = document.createElement('tr');
	tr.append(...tds);
	document.querySelector('tbody')!.append(tr);
};
